// Internal work packages. Founder never manages these as a daily surface.
// Governor seeds packages and generates Ready Founder Moves from them.

export const SEED_WORK_PACKAGES = [
  {
    id: 'wp-clock',
    epicId: 'E13',
    gateDay: 15,
    title: 'Confirm sprint clock and operating timezone',
    completionCondition: 'One canonical start/end date; Day 15/30/45 derived; any re-baseline recorded as a decision',
    evidenceCredit: 'none',
    status: 'Done',
    phase: '0-2',
    setup: true,
    founderMove: true,
    gateOutcomeId: 'go-d15-governance',
  },
  {
    id: 'wp-runway-baseline',
    epicId: 'E02',
    gateDay: 15,
    title: 'Establish runway baseline',
    completionCondition: 'Starting cash, current cash, monthly burn, minimum viable burn, and dated source recorded',
    evidenceCredit: 'none',
    status: 'Ready',
    phase: '0-2',
    setup: true,
    gateOutcomeId: 'go-d15-runway-baseline',
  },
  {
    id: 'wp-time-baseline',
    epicId: 'E03',
    gateDay: 15,
    title: 'Establish founder-time baseline',
    completionCondition: 'Weekly blocks allocated 55/20/10/10/5 and actual time-capture method enabled',
    evidenceCredit: 'none',
    status: 'Ready',
    phase: '0-2',
    setup: true,
    gateOutcomeId: 'go-d15-founder-time',
  },
  {
    id: 'wp-import-top50',
    epicId: 'E04',
    gateDay: 15,
    title: 'Import the Dubai Top 50 research',
    completionCondition: 'Accounts imported with source/confidence, not automatically promoted to opportunities',
    evidenceCredit: 'E0',
    status: 'Ready',
    phase: '0-2',
    setup: true,
    gateOutcomeId: 'go-d15-dubai-density',
  },
  {
    id: 'wp-universe',
    epicId: 'E04',
    gateDay: 15,
    title: 'Complete the universe to the chosen hypothesis',
    completionCondition: 'Current 50 expanded toward the editable 75–100 range; if 85 is selected, label it an operating hypothesis',
    evidenceCredit: 'E0',
    status: 'Ready',
    phase: '0-2',
    setup: true,
    founderMove: false,
    gateOutcomeId: 'go-d15-dubai-density',
  },
  {
    id: 'wp-verify-queue',
    epicId: 'E04',
    gateDay: 15,
    title: 'Verify the first founder queue',
    completionCondition: '10–15 accounts pass the title-owner/sponsor-authority screen and have Why Blocks, relationship path, decision-maker hypothesis, and next move',
    evidenceCredit: 'none',
    status: 'Ready',
    phase: '0-2',
    setup: true,
    gateOutcomeId: 'go-d15-dubai-density',
  },
  {
    id: 'wp-scope-cleanup',
    epicId: 'E01',
    gateDay: 15,
    title: 'Scope cleanup',
    completionCondition: 'Remove or freeze actions outside Blocks Estate/Bridge45, including the VirialAI social task unless an approved link exists',
    evidenceCredit: 'none',
    status: 'Ready',
    phase: '0-2',
    setup: true,
    founderMove: false,
    gateOutcomeId: 'go-d15-strategy-lock',
  },
  {
    id: 'wp-activate-tiera',
    epicId: 'E04',
    gateDay: 15,
    title: 'Activate 10–15 Tier-A Dubai accounts',
    completionCondition: 'Named outreach/introduction/follow-up per account',
    evidenceCredit: 'E1',
    status: 'Ready',
    phase: '1-15',
    dailyMove: 'One named outreach, introduction, or follow-up with a Tier-A Dubai sponsor.',
    gateOutcomeId: 'go-d15-dubai-density',
  },
  {
    id: 'wp-dubai-discovery',
    epicId: 'E04',
    gateDay: 15,
    title: 'Run structured Dubai discovery',
    completionCondition: 'Sponsor objective, problem, authority, why now, alternative, timing, and next step captured',
    evidenceCredit: 'E2',
    status: 'Ready',
    phase: '1-15',
    dailyMove: 'Run one structured Dubai discovery that confirms a real problem or use case.',
    gateOutcomeId: 'go-d15-dubai-density',
  },
  {
    id: 'wp-convert-discovery',
    epicId: 'E04',
    gateDay: 15,
    title: 'Convert discoveries selectively',
    completionCondition: 'Opportunity created only after a real problem/use case and plausible sponsor exist',
    evidenceCredit: 'E2',
    status: 'Ready',
    phase: '1-15',
    dailyMove: 'Convert a confirmed discovery into a qualified opportunity with a named next step.',
    gateOutcomeId: 'go-d15-dubai-density',
  },
  {
    id: 'wp-asset-commitment',
    epicId: 'E04',
    gateDay: 15,
    title: 'Ask for concrete asset commitment',
    completionCondition: 'Named asset, owner entity, basic economics, and document-access date',
    evidenceCredit: 'E3',
    status: 'Ready',
    phase: '1-15',
    dailyMove: 'Ask a named sponsor for a specific asset, owner entity, and document-access date.',
    gateOutcomeId: 'go-d15-dubai-density',
  },
  {
    id: 'wp-partner-routes',
    epicId: 'E05',
    gateDay: 15,
    title: 'Qualify regulated execution routes',
    completionCondition: 'Two architecture conversations; permissions, limitations, unknowns, and next action recorded',
    evidenceCredit: 'E2',
    status: 'Ready',
    phase: '1-15',
    dailyMove: 'Book or complete a regulated-partner architecture conversation and record permissions and unknowns.',
    gateOutcomeId: 'go-d15-partner-route',
  },
  {
    id: 'wp-saudi-pain',
    epicId: 'E08',
    gateDay: 15,
    title: 'Validate Saudi pain without expanding scope',
    completionCondition: 'First relevant B2B/regulated-market discovery conversations',
    evidenceCredit: 'E2',
    status: 'Ready',
    phase: '1-15',
    dailyMove: 'Run one Saudi discovery that confirms enterprise pain — not a market launch.',
    gateOutcomeId: 'go-d15-saudi-pain',
  },
  {
    id: 'wp-infra-pain',
    epicId: 'E07',
    gateDay: 15,
    title: 'Validate Infrastructure build-vs-buy pain',
    completionCondition: 'Named buyers and technical/commercial discovery toward a priced proposal',
    evidenceCredit: 'E2',
    status: 'Ready',
    phase: '1-15',
    dailyMove: 'Run infrastructure discovery with a named buyer on build-vs-buy pain.',
    gateOutcomeId: 'go-d15-infra-pain',
  },
  {
    id: 'wp-governance-cadence',
    epicId: 'E13',
    gateDay: 15,
    title: 'Run daily and Friday governance',
    completionCondition: 'Two-minute closeout; Friday Stop / Continue / Concentrate; constraint and next-week objective updated',
    evidenceCredit: 'none',
    status: 'Ready',
    phase: '1-15',
    dailyMove: 'Complete today’s closeout: evidence created, what moved, what rolls, newly revealed constraint.',
    gateOutcomeId: 'go-d15-governance',
  },
];

export function workPackageContext(pkg) {
  if (!pkg) return '';
  return pkg.title;
}

export function seedWorkPackages() {
  return SEED_WORK_PACKAGES.map((p) => ({ ...p }));
}

export const INITIALIZATION_PACKAGE_IDS = [
  'wp-import-top50',
  'wp-runway-baseline',
  'wp-time-baseline',
  'wp-verify-queue',
];

export function packageGeneratesFounderMove(pkg) {
  if (!pkg) return false;
  if (pkg.founderMove === false) return false;
  if (pkg.setup) return true;
  return !!pkg.dailyMove;
}

export function isInitializationPackage(pkg) {
  return !!pkg?.setup || INITIALIZATION_PACKAGE_IDS.includes(pkg?.id);
}

/**
 * Ready Founder Moves generated from packages. Idempotent against existing
 * moves that already carry the same workPackageId. Work packages that are
 * multi-day outcomes (universe, scope cleanup) do not become founder moves.
 */
export function readyMovesFromPackages(packages, existingMoves = [], today = '') {
  const have = new Set((existingMoves || []).map((a) => a.workPackageId).filter(Boolean));
  const out = [];
  for (const pkg of packages || []) {
    if (have.has(pkg.id)) continue;
    if (!packageGeneratesFounderMove(pkg)) continue;
    const setup = !!pkg.setup;
    const credit = pkg.evidenceCredit && pkg.evidenceCredit !== 'none' ? pkg.evidenceCredit : 'OPS';
    out.push({
      text: pkg.dailyMove || pkg.title,
      workstream: workstreamForEpic(pkg.epicId),
      priority: setup ? 'Critical' : 'High',
      expectedEvidence: credit,
      dueDate: today,
      owner: 'Founder',
      status: 'Ready',
      gateRelevance: String(pkg.gateDay || '15'),
      workPackageId: pkg.id,
      epicId: pkg.epicId,
      gateOutcomeKey: `g${pkg.gateDay || 15}`,
      gateOutcomeId: pkg.gateOutcomeId || '',
      completionCondition: pkg.completionCondition,
      evidenceCredit: pkg.evidenceCredit || 'none',
      source: 'Rule',
      whyNow: setup
        ? 'State is not yet trustworthy enough to rank commercial moves.'
        : `This move is the next daily slice of ${pkg.title}.`,
      selectedForToday: false,
    });
  }
  return out;
}

function workstreamForEpic(epicId) {
  if (epicId === 'E08') return 'Saudi';
  if (epicId === 'E07') return 'Infrastructure';
  if (epicId === 'E02') return 'Runway';
  if (epicId === 'E05' || epicId === 'E04') return 'Dubai';
  if (epicId === 'E12') return 'Fundraising';
  return 'Dubai';
}

/**
 * Named commercial Ready moves from Tier A (or CSV import fallback).
 * Idempotent on nexusId + move kind (or account id when unlinked).
 */
export function namedCommercialMoves(accounts = [], existingMoves = [], today = '', opts = {}) {
  const onlyTierA = !!opts.onlyTierA;
  const linked = new Set(
    (existingMoves || []).flatMap((a) => [a.idempotencyKey, a.linkedId].filter(Boolean)),
  );
  const out = [];
  const tierA = (accounts || []).filter((a) => a.tier === 'Tier A' || a.tier === 'A');
  const pool = onlyTierA ? tierA : (tierA.length ? tierA : (accounts || []).slice(0, 15));
  for (const acc of pool) {
    if (!acc?.id) continue;
    const idempotencyKey = acc.nexusId ? `nexus:${acc.nexusId}:outreach` : `acc:${acc.id}:outreach`;
    if (linked.has(idempotencyKey) || linked.has(acc.id)) continue;
    const person = acc.primaryContact || acc.decisionMaker || '';
    const name = acc.name || 'this account';
    const hypothesis = acc.whyBlocks || acc.problemConfirmed || acc.segment || 'the recorded thesis';
    const text = person
      ? `Ask ${person} for an introduction to a decision-maker at ${name}.`
      : `Contact the ${name} decision-maker around ${hypothesis}.`;
    out.push({
      text,
      workstream: 'Dubai',
      priority: 'High',
      expectedEvidence: 'E1',
      dueDate: today,
      owner: 'Founder',
      status: 'Ready',
      gateRelevance: '15',
      linkedKind: 'account',
      linkedId: acc.id,
      linkedLabel: name,
      source: 'Rule',
      whyNow: onlyTierA
        ? 'Founder accepted Tier A. Named outreach is the next commercial move.'
        : 'Imported accounts are now in state. Named outreach is the next commercial move.',
      selectedForToday: false,
      workPackageId: 'wp-activate-tiera',
      gateOutcomeId: 'go-d15-dubai-density',
      epicId: 'E04',
      idempotencyKey,
    });
    if (out.length >= 12) break;
  }
  return out;
}
